// hooks/ComponentNotification/hookNotification.ts
import { userCacheManager } from '@/lib/manager realtime/userCache';
import { useEffect, useState, useMemo } from 'react';

export function useUsersMap() {
  const [_isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState<any[]>([]);

  useEffect(() => {
    async function loadUsers() {
      try {
        setIsLoading(true);
        const userData = await userCacheManager.getUsers();
        setUsers(userData);
      } catch (error) {
        console.error('Error cargando usuarios:', error);
      } finally {
        setIsLoading(false);
      }
    }

    loadUsers();
  }, []);

  return useMemo(() => {
    const map = new Map<string, { name: string; email: string; profile: any }>();
    for (const user of users) {
      map.set(user.id, { 
        name: user.name, 
        email: user.email, 
        profile: user.profile 
      });
    }
    return map;
  }, [users]);
}